import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TranslateModule } from "@ngx-translate/core";

import { TabsComponent } from './tabs.component';
import { LocalActionsModule } from "../../../../core/local-actions/local-actions.module";
import { AngularMaterialModule } from "../../../../core/angular-material/angular-material.module";
import { DirectivesModule } from "../../../directives/directives.module";
import { FormModule } from "../../default/form/form.module";
import { IconModule } from "../../default/icon/icon.module";


@NgModule({
    declarations: [
        TabsComponent
    ],
    imports: [
        CommonModule,
        AngularMaterialModule,
        FormModule,
        // TooltipUserModule,
        DirectivesModule,
        LocalActionsModule,
        IconModule,
        TranslateModule
    ],
    exports: [
        TabsComponent
    ]
})
export class TabsModule{}
